module.exports = __webpack_public_path__ + "img/378.5f8df6f6.gif";